<style scoped>
  .city-box li {
    float: left;
    margin-bottom: 12px;
  }

  .labelC {
    float: left;
    margin-right: 5px;
    line-height: 32px;
    text-align: right;
  }

  .div-select {
    float: left;
  }
</style>
<template>
  <div>
    <!--横向-->
    <el-row v-if="direction == 'row'" :gutter="15" type="flex">
      <el-col :span="row_arr[0]">
        <!--<label :style="{width:labelW}" class="labelC">省：</label>-->
        <div class="div-select">
          <el-select clearable size="small" :style="{width:selectW}" filterable v-model="area.province" @change="provinceChange">
            <template v-for="item in $City.province">
              <el-option :key="item"
                         :label="item"
                         :value="item"></el-option>
            </template>
          </el-select>
        </div>
      </el-col>
      <el-col :span="row_arr[1]">
        <!--<label :style="{width:labelW}" class="labelC">市：</label>-->
        <div class="div-select">
          <el-select clearable size="small" :style="{width:selectW}" filterable v-model="area.city" @change="cityChange">
            <template v-for="item in cityList">
              <el-option :key="item"
                         :label="item"
                         :value="item"></el-option>
            </template>
          </el-select>
        </div>
      </el-col>
      <el-col :span="row_arr[2]">
        <!--<label :style="{width:labelW}" class="labelC">区：</label>-->
        <div class="div-select">
          <el-select clearable size="small" :style="{width:selectW}" filterable v-model="area.country">
            <template v-for="item in regionList">
              <el-option :key="item"
                         :label="item"
                         :value="item"></el-option>
            </template>
          </el-select>
        </div>
      </el-col>
    </el-row>
    <!--竖向-->
    <ul class="city-box clearfix" v-if="direction == 'col'">
      <li>
        <label :style="{width:labelW}" class="labelC">省：</label>
        <div class="div-select">
          <el-select clearable size="mini" :style="{width:selectW}" filterable v-model="area.province" @change="provinceChange">
            <template v-for="item in $City.province">
              <el-option :key="item"
                         :label="item"
                         :value="item"></el-option>
            </template>
          </el-select>
        </div>
      </li>
      <li>
        <label :style="{width:labelW}" class="labelC">市：</label>
        <div class="div-select">
          <el-select clearable size="mini" :style="{width:selectW}" filterable v-model="area.city" @change="cityChange">
            <template v-for="item in cityList">
              <el-option :key="item"
                         :label="item"
                         :value="item"></el-option>
            </template>
          </el-select>
        </div>
      </li>
      <li>
        <label :style="{width:labelW}" class="labelC">区：</label>
        <div class="div-select">
          <el-select clearable size="mini" :style="{width:selectW}" filterable v-model="area.country">
            <template v-for="item in regionList">
              <el-option :key="item"
                         :label="item"
                         :value="item"></el-option>
            </template>
          </el-select>
        </div>
      </li>
    </ul>
  </div>

</template>
<script>
  export default {
    data() {
      return {
        cityList: [],//市列表
        regionList: [],//区列表
        area: {
          province:"",
          city:"",
          country:""
        }
      }
    },
    props: {
      selectW: {//select宽度
        type: String,
        default: "100%"
      },
      labelW: {//label宽度
        type: String,
        default: "130px"
      },
      direction: {//方向
        type: String,
        default: "row"//默认col(竖向),row(横向)
      },
      data: {
        type: Object,
        default(){
          return {
            province: "",
            city: "",
            country: ""
          }
        }
      },
      isRequested: {
        type: Boolean,
        default: false
      },
      row_arr:{
        type: Array,
        default(){return [8,8,8]}
      }
    },
    watch: {
      isRequested(){
        this.area = Object.assign({}, this.data);
        this.cityList = this.$City["city"][this.area.province];
        this.regionList = this.$City["region"][this.area.city];
      }
    },
    methods: {
      provinceChange(){
        this.cityList = this.$City["city"][this.area.province];
        this.area.city = "";
        this.area.country = "";
      },
      cityChange(){
        this.regionList = this.$City["region"][this.area.city];
        this.area.country = "";
      }
    },
    mounted(){
      // console.log(this.data);
      this.area=this.data;
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/City/city.vue